import React, { Fragment, useEffect, useMemo, useState } from 'react';
import styles from '../invoice.module.css';
// import { PopUpAddColName } from './popUpAddCol';
import swal from 'sweetalert';
import { TableDropdown } from './dropdown';
import { useSearchParams } from 'react-router-dom';
import { useGetRules } from '../hooks';
import { Autocomplete, TextField } from '@mui/material';
import { sortDropdownOptions } from '../../utils';


function TableList({selectedEntity, setselectedEntity, setchangePage, IsCSV, tablesExtracted, settablesExtracted, setBoxes, setchangeDetect, setchangeAdd, DocLockedForMe , MismatchIds , PageNo, gotoMismatch}) {
	/* const [column, setColumn] = React.useState('');
	const handleChange = (event) => {
		setColumn(event.target.value);
	}; */
	// const [IsOpened, setIsOpened] = useState(false);
	// const [tb, settb] = useState(null);
	const [isDeleteEnable, setisDeleteEnable] = useState({})

	function DeleteColPop(tableName, col) {
		swal('Are you sure you want to Delete this column?', {
			buttons: ['No', 'Yes'],
		}).then((value) => {
			if (value) {
				// setBoxes(p=> {
				// 	let tpbx = [...p].filter(bx => !(bx.table ===tableName && bx.entity ===col) )
				// 	return tpbx
				// })
				settablesExtracted(prev => {
					let tempTables = { ...prev }
					Object.keys(tempTables[tableName]).map(row => {
						let newrow = tempTables[tableName][row].filter(obj => obj.entity !== col)
						tempTables[tableName][row] = newrow
					return null
					})
					return tempTables
				})
				if (DocLockedForMe){
					setchangeDetect(true)
					setchangeAdd(p=>p+1)
				}
			} else {
				// User clicked "No" button or closed the dialog
				// Add any additional logic you want when the user clicks "No" or closes the dialog
			}
		});
	}

	function DeleteRowPop(tableName, rowName) {
		swal('Are you sure you want to Delete this row?', {
			buttons: ['No', 'Yes'],
		}).then((value) => {
			if (value) {
				// setBoxes(p=> {
				// 	let tpbx = [...p].filter(bx => !(bx?.table ===tableName && bx?.row_name ===rowName) )
				// 	return tpbx
				// })
				settablesExtracted(prev => {
					let tempTables = { ...prev }
					delete tempTables[tableName][rowName]
					return tempTables
				})
				if (DocLockedForMe){
					setchangeDetect(true)
					setchangeAdd(p=>p+1)
					setchangePage(p=> {
						return {
							...p,
							[PageNo]: true
						}
					})
				}
			} else {
				// User clicked "No" button or closed the dialog
				// Add any additional logic you want when the user clicks "No" or closes the dialog
			}
		});
	}

	function handleValChange(tableName , row_name , colInd , value) {
		settablesExtracted(prev => {
			let tempTables = { ...prev }
			tempTables[tableName][row_name][colInd] = {...tempTables[tableName][row_name][colInd] , value : value}
			return tempTables
		})
		if (DocLockedForMe){
			setchangeDetect(true)
			setchangeAdd(p=>p+1)
			setchangePage(p=> {
				return {
					...p,
					[PageNo]: true
				}
			})
		}
	}

	function handleLableChange(tableName , colInd , value) {
		if (value === '' || value === null || value === undefined) {
			swal('Column label cannot be empty');
			return
		}
		settablesExtracted(prev => {
			let tempTables = { ...prev }
			Object.keys(tempTables[tableName]).map(row => {
				tempTables[tableName][row][colInd] = {...tempTables[tableName][row][colInd] , entity : value.toLocaleUpperCase()}
			return null 
			})
			return tempTables
		})
		if (DocLockedForMe){
			setchangeDetect(true)
			setchangeAdd(p=>p+1)
			setchangePage(p=> {
				return {
					...p,
					[PageNo]: true
				}
			})
		}
	}

		function addTableHandle() {
		if (DocLockedForMe){
			setchangeDetect(true)
			setchangeAdd(p=>p+1)
		}
		let newInd = Object.keys(tablesExtracted).reduce((acc, cur) => {
			let num = parseInt(cur.replace('table ', ''))
			if (num > acc) {
				acc = num
			}
			return acc
		}, 0) + 1

		settablesExtracted(prev => {
			let tempTables = {...prev}
			tempTables[`table ${newInd}`] = {}
			return tempTables
		})
	}
    	const [searchParams] = useSearchParams();
	
		const [RulesFromServer, setRulesFromServer] = useState(null)
		
		const get_rules_hook = useGetRules( searchParams.get('category_id'), searchParams.get('vendor_id'))
		
		useEffect(() => {
			if (get_rules_hook.isSuccess && get_rules_hook.data?.data) {
				let arr = get_rules_hook.data?.data.rules
				arr = sortDropdownOptions(arr, (a) => a.entity_name);
				setRulesFromServer(arr)
	
			}
		}, [get_rules_hook.isSuccess, get_rules_hook.data])
	
		let TableLables = useMemo(() => {
				if (RulesFromServer !==null) {
					let filteredFeilds = [...RulesFromServer].filter(itm => {
						if (itm.entity_type === 'multivalued') {
							return true
						}
						else{
							
							return false
						}
					}).map(itm => itm.entity_name.toLowerCase() )
					
					return sortDropdownOptions(filteredFeilds)
				}
				else {
					return []
				}
				
		
			}, [RulesFromServer])
		
			
					
	





	return (
		<>
			{/* Below - List loop of #Table */}

			<div key='table_section' className={`${styles.invFieldsWrap} overflow-auto py-4 pl-6`}>
				{tablesExtracted !== null &&
					Object.keys(tablesExtracted).map((tableName) => {
						let table = tablesExtracted[tableName];
						return (
							<div key={`tb_name_${tableName}`}>
								<TableDropdown PageNo={PageNo} setchangePage={setchangePage} IsCSV={IsCSV} settablesExtracted={settablesExtracted} tableName={tableName} setisDeleteEnable={setisDeleteEnable} isDeleteEnable={isDeleteEnable} setchangeDetect={setchangeDetect} setchangeAdd={setchangeAdd} DocLockedForMe={DocLockedForMe} />
								<div className={`${styles.boxTableCtnr} overflow-auto mb-4 py-2`}>
									<table className={styles.bxTable}>
										<tbody>
										{Object.keys(table).map((row_name, rowInd) => {
											let row_lst = table[row_name];
											return (
												<Fragment key={`table_row_${rowInd}`} >
													{rowInd === 0 && (
														<tr key={`${tableName}_${row_name}_lable`}>
															{row_lst.length !==0 &&
															<td className={`${styles.stik} w-10 text-right`}>
																<span className='inline-block text-center rounded-md size-6 leading-6 bg-gray-300 border border-gray-400 text-sm'>#</span>
															</td> }
															{row_lst.map((cell, colInd) => {
																return (
																	<td
																		key={`${tableName}_${row_name}_${colInd}_lable`}
																		className='border-0 p-0'
																	>
																		<div
																			onClick={() =>
																				setselectedEntity(cell.entity)
																			}
																			className={`!border-0 !p-0 ${styles.lblBdr} flex gap-0 w-44`}
																		>
																			<button
																				disabled={IsCSV || !DocLockedForMe}
																				onClick={() =>
																					DeleteColPop(tableName, cell.entity)
																				}
																				className="leading-none mt-[2px]"
																			>
																				{isDeleteEnable[tableName] && <span className="material-icons-outlined text-sm text-red-600">
																					cancel
																				</span>}
																			</button>
																			{/* <div
																				
																				className={`relative flex items-center cursor-pointer`}
																			>
																				<span
																					title={cell.entity}
																					className={`${selectedEntity?.toLocaleLowerCase() == cell.entity?.toLocaleLowerCase() ? 'bg-green-400' :'' } ${styles.text2Lines}  block text-gray-600`}
																				>
																					{cell.entity}
											
																					
																				</span>
											
																				
																			</div> */}
																			<div className="grow w-full">
																				<div className="grow w-full">
																					<Autocomplete
																						id="fields"
																						options={TableLables}

																						getOptionLabel={(option) =>
																							typeof option === 'string'
																								? option
																								: option.entity_name
																						}
																						isOptionEqualToValue={(
																							option,
																							value
																						) =>
																							option?.toLocaleLowerCase()
																							 === value?.toLocaleLowerCase()
																						}
																						className={`${selectedEntity?.toLocaleLowerCase() == cell.entity?.toLocaleLowerCase() ? 'bg-green-400' : ''} ${styles.text2Lines} font-bold text-sm outline-none `}
																						value={cell.entity}
																						onChange={(event, newValue) => {
																							handleLableChange(
																							tableName,
																							colInd,
																							newValue
																						)
																						}}
																						title={cell.entity}
																						loading={get_rules_hook.isFetching}
																						loadingText="Loading..."
																						renderInput={(params) => (
																							<TextField
																								{...params}
																								// label="Fields"
																								fullWidth
																							/>
																						)}
																						renderOption={(props, option) => {
																							return (
																								<li {...props} key={option}>
																									{option}
																								</li>
																							);
																						}}
																					/>
																				</div>

																				{/* <input
																					title={cell.entity}
																					disabled={IsCSV || !DocLockedForMe}
																					type="text"
																					// className={styles.invFldInput}
																					className={`${selectedEntity?.toLocaleLowerCase() == cell.entity?.toLocaleLowerCase() ? 'bg-green-400' : ''} ${styles.text2Lines} font-bold text-sm outline-none`}
																					value={cell.entity}
																					onChange={(e) =>
																						handleLableChange(
																							tableName,
																							colInd,
																							e.target.value
																						)
																					}
																				/> */}
																			</div>

																			{/* <div onClick={()=> setselectedEntity(cell.entity)} className="grow">
																				<input 
																					title={cell.entity}
																					disabled={true}
																					type="text"
																					// className={styles.invFldInput}
																					className={`${selectedEntity.toLowerCase() == cell.entity.toLowerCase() ? 'bg-green-300': '' } ${styles.text2Lines} font-bold text-sm outline-none cursor-pointer`}
																					value={cell.entity}
																					
																					onChange={(e)=>handleLableChange(tableName , colInd , e.target.value)}
																				/>
																					
																				
																			</div> */}
																		</div>
																	</td>
																);
															})}
														</tr>
													)}


													<tr key={`${tableName}_${row_name}`}>
														{row_lst.length !==0 &&
														<td className={`${styles.stik}`}>
															<div className='flex gap-2'>
																<button
																	disabled={IsCSV || !DocLockedForMe}
																	onClick={() => DeleteRowPop(tableName, row_name)}
																	className={`${styles.cnclCell}`}
																>
																	{isDeleteEnable[tableName] && <span className="material-icons-outlined text-xs text-red-600">
																		cancel
																	</span>}
																</button>
																<span className='inline-block text-center rounded-md size-6 leading-6 bg-gray-300 border border-gray-400 text-sm'>
																	{rowInd + 1}
																</span>
															</div>
														</td> }
														{row_lst.map((cell, colInd) => {
															return (

																<td key={`${tableName}_${row_name}_${colInd}`}>
																	<div className={`${styles.tdInputBx} block w-44`}>
																		<input
																			title={cell.value}
																			disabled={IsCSV || !DocLockedForMe}
																			type="text"
																			className={`${styles.invFldInput} !h-10`}
																			value={cell.value}
																			onChange={(e)=>handleValChange(tableName , row_name , colInd , e.target.value)}
																		/>
																		
																		<div className={styles.fltIco}>
																		{MismatchIds[PageNo][cell?.mismatch_id] && ['Approved', 'Pending', 'true'].includes(MismatchIds[PageNo][cell?.mismatch_id]) &&  cell.mismatch_id && 
																				<span title={MismatchIds[PageNo][cell?.mismatch_id]} onClick={()=>gotoMismatch(cell?.mismatch_id)} 
																				className="exclamation-icon cursor-pointer ">
																				
																				</span>
																			}
																			{cell.entity_valid === 'true' && (
																				<span
																					title={
																						cell.entity_validation_explanation
																					}
																					className="material-icons cursor-default text-green-500 text-xs"
																				>
																					check_circle
																				</span>
																			)}
																			{cell.entity_valid === 'false' && (
																				<span
																					title={
																						cell.entity_validation_explanation
																					}
																					className="material-icons cursor-default text-red-500 text-xs"
																				>
																					check_circle
																				</span>
																			)}
																			{cell.entity_valid === 'none' && (
																				<span
																					title={
																						cell.entity_validation_explanation
																					}
																					className="material-icons cursor-default text-gray-500 text-xs"
																				>
																					check_circle
																				</span>
																			)}
																			
																		</div>
																	</div>
																</td>
															);
														})}
													</tr>

												</Fragment>

											);
										})}
										</tbody>
										
									</table>
								</div>
							</div>
						);
					})}

				<div className='w-44 text-left pt-2'>
						{!IsCSV && <button
							disabled={IsCSV || !DocLockedForMe}
							type="button"
							onClick={() => addTableHandle()}
							className="bg-blue-200 hover:bg-indigo-400 px-4 py-2 rounded-md text-primary text-sm hover:text-white flex items-center font-black disabled:bg-gray-200 disabled:text-gray-500 disabled:hover:text-gray-500"
						>
							<span className="material-icons text-sm mr-1">add</span>Add Table
						</button>}
					</div>
			</div>
			{/* {IsOpened && (
				<PopUpAddColName
					IsOpened={IsOpened}
					setIsOpened={setIsOpened}
					tablesExtracted={tablesExtracted}
					settablesExtracted={settablesExtracted}
					table={tb}
				/>
			)} */}

			{/* <div className='flex gap-3 justify-end px-6 py-4'>
                <div>
                    <button type='button'
                        className='bg-blue-200 hover:bg-indigo-400 px-4 py-2 rounded-md text-primary text-sm hover:text-white flex items-center font-black'>
                        <span className="material-icons text-sm mr-1">add</span>Add
                    </button>
                </div>
                <div>
                    <button type='button'
                        className='bg-blue-200 hover:bg-indigo-400 px-4 py-2 rounded-md text-primary text-sm hover:text-white flex items-center font-black flex items-center'>
                        <span className="cIco createBoxIco mr-1"></span>Create Box
                    </button>
                </div>
            </div> */}
		</>
	);
}

export default TableList;
